// extracted by mini-css-extract-plugin
export default {"homeClass":"MfCsBhGn6M2PdP_exAlg","loginClass":"oU7PEn8gl5r2vm5AA4Ko","appMainClass":"QMDj2SeFg1FU8zxpOFDV","profileClass":"nS6xAe3LW4__tO4iOinK","legalClass":"FXZGPs8zbsN_YlGlU5Ve"};